import { storeToRefs } from "pinia";
import { useAppStore } from "../stores/appStore";
import { useChatStore } from "../stores/chatStore";
import type { Message } from "../types/chat/Message";
import { MessageType } from "../types/chat/MessageType";

function htmlToPlainText(html: string): string {
  if (!html) return ''
  const el = document.createElement('div')
  el.innerHTML = html
  return el.innerText || el.textContent || ''
}

export function exportChatText(){
    const chatStore = useChatStore()
        const appStore = useAppStore()
        const { messages } = storeToRefs(chatStore)
    
        const transcriptMessagePairs = appStore.configuration?.components.supportRequest.messagePairs || 3

        let output = ''
    
        function buildAlternatingMessages() {
        const cleanedMessages: Message[] = messages.value
            .filter(m => !m.isLoading && !!m.text)
            .map(m => ({
            ...m,
            text: htmlToPlainText(m.text).trim(),
            }))
            .filter(m => m.text.length > 0)
    
        if (!cleanedMessages.length) {
            console.warn('No messages to export')
            return ''
        }
    
        const totalPairs = Math.floor(cleanedMessages.length / 2)
        const pairsToUse = Math.min(transcriptMessagePairs, totalPairs)
    
        const sliceSize = pairsToUse * 2
        const sourceMessages = cleanedMessages.slice(-sliceSize)

        sourceMessages.forEach(msg => {
            const raw = msg.text  
            const isUser = msg.type === MessageType.User
                  const caption = isUser ? 'User prompt' : 'Agent response'

            output += `${caption}:\n ${raw} \n`
        })

        return output.trimEnd()
    }
    
    return {buildAlternatingMessages}
}